<template>
  <div id="app" @click="handleOperateSearchModal">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>

    <div
      id="floating-window"
      class="floating-div"
      style=" align-items: center; width: auto"
    >
      <!-- 悬浮内容 -->
      <div class="floating-toggle" @click="showMoreChange">
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
          <rect y="0" width="20" height="2.5" rx="1.25" fill="#d7000F"/>
          <path v-if="showMore" d="M2.5 7 L12 7 L12 5 L17 8 L12 11 L12 9 L2.5 9 Z" fill="#d7000F"/>
          <path v-else d="M17.5 7 L8 7 L8 5 L3 8 L8 11 L8 9 L17.5 9 Z" fill="#d7000F"/>
          <rect y="13.5" width="20" height="2.5" rx="1.25" fill="#d7000F"/>
        </svg>
      </div>
      <div v-if="showMore" class="floating-content">
        <a-button
          class="customBtn"
          @click="dialogOpen = true"
          style="
            background: #EDE5D8;
            border-radius: 8px;
            width: 100%;
            height: 48px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
          "
        >
          <img src="@/assets/img/canzhanzixun.png" class="btnImg" />
          <div style="font-size: 18px; color: #5C4A3A; padding-left: 6px; font-weight: 500; line-height: 1;">
            {{ $t("h.floatingBox.label1") }}
          </div>
        </a-button>
        <a-button
          @click="registerBtn('zs')"
          class="customBtn"
          style="
            background: #EDE5D8;
            border-radius: 8px;
            width: 100%;
            height: 48px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            line-height: 1;
          "
        >
          <img src="@/assets/img/zhanweishenqing.png" class="btnImg" />
          <div style="font-size: 18px; color: #5C4A3A; padding-left: 6px; font-weight: 500; line-height: 1;">
            {{ $t("h.floatingBox.label2") }}
          </div>
        </a-button>
        <a-button
          @click="registerBtn('gz')"
          class="customBtn"
          style="
            background: #EDE5D8;
            border-radius: 8px;
            width: 100%;
            height: 48px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            line-height: 1;
          "
        >
          <img src="@/assets/img/guanzhongyudengji.png" class="btnImg2" />
          <div style="font-size: 18px; color: #5C4A3A; padding-left: 6px; font-weight: 500; line-height: 1;">
            {{ $t("h.floatingBox.label3") }}
          </div>
        </a-button>
        <div
          class="customBtn"
          style="
            background: #EDE5D8;
            border-radius: 8px;
            width: 100%;
            height: 48px;
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
          "
        >
          <div style="font-size: 16px; color: #5C4A3A; font-weight: 500; line-height: 1;">
            {{ $t("h.floatingBox.label4") }}
          </div>
          <div style="display: flex; align-items: baseline; padding-left: 6px; line-height: 1;">
            <div style="font-size: 24px; color: #d7000F; font-weight: bold; line-height: 1;">
              <CountTo :startVal="0" :endVal="remainingDays" :duration="3000" />
            </div>
            <div style="font-size: 14px; color: #5C4A3A; padding-left: 2px; line-height: 1;">
              {{ $t("h.floatingBox.label5") }}
            </div>
          </div>
        </div>
       <a-button
          @click="chatOpen = !chatOpen"
          class="customBtn"
          style="
            background: #EDE5D8;
            border-radius: 8px;
            width: 100%;
            height: 68px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            line-height: 1;
          "
        >
         <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#5C4A3A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <div style="font-size: 24px; color: #5C4A3A; padding-left: 10px; font-weight: 600; line-height: 1;">
            {{ $t('h.floatingBox.label6') || 'Keno 智能体' }}
          </div>
        </a-button>
      </div>
    </div>

    <!-- 聊天 iframe -->
    <div
      v-show="chatOpen"
      style="
        position: fixed;
        bottom: 80px;
        right: 140px;
        width: 380px;
        height: 580px;
        max-width: calc(100vw - 160px);
        max-height: calc(100vh - 100px);
        z-index: 1000;
        box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);
        border-radius: 16px;
        overflow: hidden;
      "
    >
      <iframe
        :src="chatUrl"
        style="
          width: 100%;
          height: 100%;
          border: none;
          display: block;
        "
      ></iframe>
    </div>
    <router-view name="footer"></router-view>
    <a-modal
      width="400px"
      centered
      :visible="dialogOpen"
      :footer="null"
      @cancel="() => (dialogOpen = false)"
      style="border-radius: 8px; overflow: hidden;"
    >
      <img
        v-if="$language === 'ZH'"
        src="@/assets/img/baomingcanzhan.png"
        alt=""
        style="width: 100%; border-radius: 8px;"
      />
      <div v-else style="padding: 30px; text-align: left; background-color: #f9f9f9; border-radius: 8px;">
        <h3 style="color: #d7000F; margin-bottom: 24px; text-align: center; font-size: 24px; font-weight: bold;">Contact Us</h3>
        <div style="font-size: 16px; line-height: 32px; background-color: #ffffff; padding: 20px; border-radius: 6px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
          <div style="font-weight: bold; margin-bottom: 8px;">Mr. Alex Gu</div>
          <div style="margin-bottom: 8px;">Messe Düsseldorf (Shanghai) Co., Ltd.</div>
          <div style="margin-bottom: 8px; color: #333333;">
            <span style="font-weight: bold;">Email:</span>&nbsp;&nbsp;<a href="mailto:alex.gu@mds.cn" style="color: #1890ff; text-decoration: none;">alex.gu@mds.cn</a>
          </div>
          <div style="color: #333333;">
            <span style="font-weight: bold;">Tel:</span>&nbsp;&nbsp;+86 021 6169 8373
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import CountTo from "vue-count-to";
import { EventBus } from "@/assets/event-bus";

export default {
  components: {
    FadeTransition,
    CountTo,
  },
  data() {
    return {
      dialogOpen: false,
      showMore: false,
      remainingDays: 0,
	  chatOpen: false,
	  chatUrl: 'https://4nzgv4jr3k.coze.site/embed?api_base=https://4nzgv4jr3k.coze.site',  // 替换为实际地址
    };
  },
  beforeCreate() {
    window.removeEventListener("resize", this.checkScreenResolution);
    document.querySelector("body").setAttribute("class", "bodyOverflow");
  },
  created() {
    this.init();
    this.checkScreen();
	this.checkScreenResolution(); 
  },
mounted() {
  this.checkScreenResolution();
  // 检测浏览器语言并设置默认语言
  if (!localStorage.getItem("lang")) {
    const browserLang = navigator.language || navigator.userLanguage;
    const lang = browserLang && browserLang.startsWith('zh') ? "ZH" : "EN";
    localStorage.setItem("lang", lang);
  }
  window.addEventListener("resize", this.checkScreenResolution);
  window.addEventListener("scroll", this.handleScroll);
  
  // ===== 新增：监听聊天窗口关闭消息 =====
  window.addEventListener("message", this.handleChatClose);
  
  // ===== 新增：延迟预加载 iframe =====
  setTimeout(() => {
    this.chatUrl = 'https://4nzgv4jr3k.coze.site/embed?api_base=https://4nzgv4jr3k.coze.site';
  }, 3000);
},
    beforeDestroy() {
      window.removeEventListener("message", this.handleChatClose);
    },
  methods: {
	  toggleChat() {
	    this.chatOpen = !this.chatOpen;
	  },
	
	  handleChatMessage(event) {
	    if (event.data && event.data.type === 'chat-close') {
	      this.chatOpen = false;
	    }
	  },
    checkScreenResolution() {
      // 逻辑已提前到 index.html <head> 内联执行（window.wireRedirectCheck），
      // 此处仅保留窗口 resize 场景的兜底
      if (window.wireRedirectCheck) {
        window.wireRedirectCheck();
      }
    },
    checkScreen() {},
    handleOperateSearchModal() {
      EventBus.$emit("handleOperateSearchModal", false);
    },
    handleScroll() {
      EventBus.$emit("handleOperateSearchModal", false);
    },
    init() {
      EventBus.$emit("handleOperateSearchModal", false);
      let oneDay = this.$moment(new Date()).format("YYYY-MM-DD");
      this.remainingDays = Math.abs(
        this.$moment(oneDay).diff("2026-09-21", "day")
      );
      EventBus.$on("handleAppShowMore", () => {
        this.showMore = false;
      });
      if (this.$route.path === "/") {
        this.showMore = true;
      }
      // const floatingWindow = document.getElementById('floating-window');
      // let isDragging = false;
      // let initialX;
      // let initialY;
      // let initialLeft;
      // let initialTop;
      //
      // floatingWindow.addEventListener('mousedown', (e) => {
      //   isDragging = true;
      //   initialX = e.clientX - floatingWindow.offsetLeft;
      //   initialY = e.clientY - floatingWindow.offsetTop;
      //   initialLeft = floatingWindow.offsetLeft;
      //   initialTop = floatingWindow.offsetTop;
      // });
      //
      // document.addEventListener('mousemove', (e) => {
      //   if (!isDragging) return;
      //   const newLeft = e.clientX - initialX;
      //   const newTop = e.clientY - initialY;
      //   floatingWindow.style.left = `${newLeft}px`;
      //   floatingWindow.style.top = `${newTop}px`;
      // });
      //
      // document.addEventListener('mouseup', () => {
      //   isDragging = false;
      //   // 吸附逻辑
      //   const windowWidth = window.innerWidth || document.documentElement.clientWidth;
      //   const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      //   const floatingWindowWidth = floatingWindow.offsetWidth;
      //   const floatingWindowHeight = floatingWindow.offsetHeight;
      //
      //   if (parseFloat(floatingWindow.style.left) <= 20) {
      //     // 靠近左侧时吸附
      //     floatingWindow.style.left = '10px';
      //   } else if (windowWidth - parseFloat(floatingWindow.style.left) - floatingWindowWidth <= 20) {
      //     // 靠近右侧时吸附
      //     floatingWindow.style.left = `${windowWidth - floatingWindowWidth - 24}px`;
      //   }
      //   if (parseFloat(floatingWindow.style.top) <= 120) {
      //     // 靠近顶部时吸附
      //     floatingWindow.style.top = '154px';
      //   } else if (windowHeight - parseFloat(floatingWindow.style.top) - floatingWindowHeight <= 20) {
      //     // 靠近底部时吸附
      //     floatingWindow.style.top = `${windowHeight - floatingWindowHeight + 132}px`;
      //   }
      // });
    },
    registerBtn(value) {
       this.$router.push(value === "gz" ? "/vistor/register-gz" : "/zwApply");
    },
/*registerBtn(value) {
      if (value === "gz") {
        // 判断当前语言，跳转不同链接
        if (this.$i18n.locale === 'ZH' || this.$i18n.locale === 'zh') {
          // 中文跳转至链接1
		  window.open("https://oa.tonggao.info/CN/Customer/Login?projectCode=tg8dd8cacf7cf962a", "_blank");
          //window.location.href = "https://oa.tonggao.info/CN/Customer/Login?projectCode=tg8dd8cacf7cf962a"; // 替换为实际链接1
        } else {
          // 英文跳转至链接2		  window.open("https://oa.tonggao.info/CN/Customer/Login?projectCode=tg8dd8cacf7cf962a", "_blank");
		  window.open("https://oa.tonggao.info/EN/Customer/Login?projectCode=tg8dd8cacf7cf962a&source=", "_blank");

          //window.location.href = "https://oa.tonggao.info/EN/Customer/Login?projectCode=tg8dd8cacf7cf962a&source="; // 替换为实际链接2
        }
      } else {
        // 其他情况（如展位申请）仍走原逻辑
        this.$router.push("/zwApply");
      }
    },*/
    showMoreChange() {
      this.showMore = !this.showMore;
    },
	
	handleChatClose(event) {
	  if (!event || !event.data) return;
	  const data = event.data;
	  const type = data.type || data.event || data.action;
	  const closeTypes = ["chat-close", "close", "exit", "hide", "chatClose"];
	  if (closeTypes.includes(type)) {
	    this.chatOpen = false;
	  }
	},
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: Arial, Helvetica, "Adobe 黑体 Std", "微软雅黑", sans-serif;
}

/* 全局样式修复右侧空白 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

.bodyOverflow {
  overflow: auto !important;
  width: 100% !important;
  overflow-x: hidden !important;
}

.ant-modal-wrap-open {
  overflow: initial !important;
  overflow-y: scroll; /* 或者其他你希望的滚动条样式 */
  overflow-x: hidden !important;
}

img {
  object-fit: cover;
  object-position: center;
}

.search .highlight {
  color: #d7000F;
  font-weight: 100;
}

.myPagination {
  .ant-pagination-item-active {
    border-color: rgb(233, 26, 19);
    background-color: rgb(233, 26, 19);

    a {
      color: #fff;
    }
  }
}

/* 确保main标签没有右侧空白 */
main {
  width: 100%;
  overflow-x: hidden;
  padding-top: 102px;
}

/* 确保所有容器元素都没有右侧空白 */
.container, .wrapper, .content {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

@import "assets/main.css";

.floating-div {
  height: auto;
  position: fixed;
  top: 60%;
  right: 10px;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
  z-index: 999;
}

.floating-toggle {
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 10px 8px 8px;
}

.floating-menu-icon {
  color: #d7000F;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
}

.floating-content {
  padding: 12px;
}

.btnText {
  font-size: 18px;
  color: #5C4A3A;
  padding-left: 6px;
  font-weight: 500;
}

.btnImg {
  width: 24px;
  height: 24px;
}

.btnImg2 {
  width: 24px;
  height: 20px;
}
@media (max-width: 768px) {
  iframe[style*="bottom: 20px"] {
    right: 10px !important;
    bottom: 10px !important;
    width: calc(100vw - 20px) !important;
    height: calc(100vh - 20px) !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 12px !important;
  }
}
</style>
